<template>
	<div class="mod-order" v-loading="contLoading" element-loading-text="加载中，请稍后...">
		<div class="page_wrapper">
			<div class="content">
				<div class="top_breadcrumb">
					<el-breadcrumb separator="/">
						<el-breadcrumb-item :to="{ path: '/' }"><img class="home_img" src="@/assets/img/home.png" alt="" />首页</el-breadcrumb-item>
						<el-breadcrumb-item :to="fromUrl">
							<a>{{ fromTitle }}</a>
						</el-breadcrumb-item>
						<el-breadcrumb-item>{{ orderTypeCH }}</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="main" v-if="stepsInfo && stepsInfo.childrenList.length > 0" v-loading="modLoadding" element-loading-text="数据加载中">
					<div class="mod-title">
						<h1>{{ stepsInfo.stepName }}</h1>
						<span class="under-line"></span>
					</div>
					<div class="main-content">
						<el-steps :active="active" align-center finish-status="success" style="width: 556px; margin: 20px auto 33px">
							<el-step :title="step.stepName" v-for="(step, index) of stepsInfo.childrenList" :key="index"> </el-step>
						</el-steps>
						<!-- <div><el-button type="danger" size="mini" round >批量删除样品</el-button></div> -->
						<div class="modlist">
							<section class="modinfo" v-for="(mod, mindex) of modList" :key="mindex">
								<div class="topbox">
									<h3 class="modName">{{ mod.moduleName }} {{ mod.moduleNameEn == 'goodsInfo' ? mindex + 1 : '' }}</h3>
									<div class="btnfun" v-if="mod.moduleNameEn == 'goodsInfo'">
										<!-- v-if="modList.length > 1" -->
										<el-button type="text" round size="mini" v-if="modList.length > 1" @click="batchDel(modList, mod)">批量删除</el-button>
										<el-button type="text" round size="mini" style="padding: 7px 0" @click="deleteHandle(mod)" v-if="mindex != 0">删除</el-button>
										<el-button type="text" round size="mini" @click="copyHandle(mod)">复制</el-button>
									</div>
								</div>
								<div class="itemList">
									<template v-if="mod.layout === 'FORM'">
										<d-form :dataForm="mod" :optionList="optionList" @updateProd="updateProdInfo" ref="Cform"></d-form>
									</template>
									<template v-if="mod.layout === 'TABLE'">
										<el-table
											:data="mod.data"
											border
											@selection-change="args => selectionItemsHandle(args, mindex)"
											@cell-click="(row, column, cell, event) => cellClick(row, column, cell, event, mod)"
											:header-cell-style="{ background: '#F2F3F5' }"
											size="mini"
											max-height="500"
											style="width: 100%; margin-bottom: 20px"
										>
											<el-table-column type="selection" header-align="center" align="center" width="50"> </el-table-column>
											<template v-for="(col, idx) of mod.header">
												<!-- <el-table-column :prop="col.field" :label="col.label" v-if="col.showed" header-align="center" align="center" :key="idx"> </el-table-column> -->

												<el-table-column :prop="col.field" :label="col.label" v-if="col.showed" header-align="center" align="center" :key="idx">
													<template scope="scope">
														<template v-if="col.options.disabled == false">
															<el-input
																ref="canDditInput"
																v-model="scope.row[col.field]"
																class="edit-input"
																size="mini"
																@keyup.enter.native="enterBlur(scope)"
																@keyup.esc.native="esc(scope)"
															/>
														</template>
														<span v-else>{{ scope.row[col.field] }}</span>
													</template>
												</el-table-column>
											</template>
										</el-table>
									</template>
									<template v-if="mod.childrenList && mod.childrenList.length > 0">
										<section class="modinfo" v-for="(child, cindex) of mod.childrenList" :key="cindex">
											<div class="topbox">
												<h3 class="modName">{{ child.moduleName }}</h3>
											</div>
											<div class="itemList">
												<template v-if="child.layout === 'FORM'">
													<d-form :dataForm="child" :optionList="optionList" @updateProd="updateProdInfo" ref="Cform"></d-form>
												</template>
												<template v-if="child.layout === 'TABLE'">
													<el-table
														:data="child.data"
														ref="itemTable"
														border
														@selection-change="args => selectionItemsHandle(args, mindex, child.data)"
														@cell-click="(row, column, cell, event) => cellClick(row, column, cell, event, child)"
														:header-cell-style="{ background: '#F2F3F5' }"
														size="mini"
														max-height="500"
														style="width: 100%; margin-bottom: 20px"
													>
														<el-table-column type="selection" header-align="center" align="center" width="50"> </el-table-column>
														<template v-for="(col, idx) of child.header">
															<!-- <el-table-column :prop="col.field" :label="col.label" v-if="col.showed" header-align="center" align="center" :key="idx"> </el-table-column> -->
															<el-table-column :prop="col.field" :label="col.label" v-if="col.showed" header-align="center" align="center" :key="idx">
																<template scope="scope">
																	<template v-if="col.options.disabled == false">
																		<el-input
																			ref="canDditInput"
																			v-model="scope.row[col.field]"
																			class="edit-input"
																			size="mini"
																			:disabled="scope.row.isCanEdit"
																			@keyup.enter.native="enterBlur(scope)"
																			@keyup.esc.native="esc(scope)"
																		/>
																	</template>
																	<span v-else>{{ scope.row[col.field] }}</span>
																</template>
															</el-table-column>
														</template>
													</el-table>
												</template>
											</div>
										</section>
									</template>
								</div>
							</section>
						</div>
						<div class="btngroup">
							<el-button class="up" round @click="upHandle" v-if="active !== 0">上一步</el-button>
							<el-button type="primary" round class="next" @click="nextHandle" v-if="stepsInfo.childrenList.length > 0 && active !== stepsInfo.childrenList.length - 1">下一步</el-button>
							<el-button type="primary" round class="next" @click="submitFormHandle(1)" v-if="active === stepsInfo.childrenList.length - 1">保存</el-button>
							<el-button type="primary" round class="next" @click="submitFormHandle()" v-if="active === stepsInfo.childrenList.length - 1">提交</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 提交成功 -->
		<order-success v-if="orderSuccessVisible" ref="orderSuccess"></order-success>
		<!-- 预约失败 -->
		<order-fail v-if="orderFailVisible" ref="orderFail" @showTimePanel="showTimePanel"></order-fail>
		<!-- 时间面板 -->
		<timepanel v-if="timepanelVisible" ref="timepanel" @updateTime="updateTime"></timepanel>

		<!-- 复制几份 -->
		<order-copy-num ref="orderCopyNum" @copyNumHandle="copyNumHandle"></order-copy-num>

		<!-- 批量删除样品 -->
		<OrderSampleDel ref="orderSampleDel" :delModDt="delModDt" @batchDelHandle="batchDelHandle"></OrderSampleDel>
	</div>
</template>

<script>
import DForm from '@/components/DForm/DForm'
import OrderSuccess from '@/views/common/dialog/OrderSuccess'
import OrderFail from '../common/dialog/OrderFail.vue'
import Timepanel from '../common/Timepanel.vue'
import OrderCopyNum from './../common/dialog/OrderCopyNum.vue'
import OrderSampleDel from './../common/dialog/OrderSampleDel.vue'
import { debounce } from '@/utils/common1'
export default {
	components: {
		DForm,
		OrderSuccess,
		OrderFail,
		Timepanel,
		OrderCopyNum,
		OrderSampleDel,
	},
	data() {
		return {
			orderId: '',
			orderType: '',
			fromTitle: '',
			fromUrl: '',
			stepsInfo: null,
			active: 0,
			modLoadding: false,
			modList: null,
			dataListSelections: [],
			itemVisible: false,
			orderSuccessVisible: false,
			orderFailVisible: false,
			timepanelVisible: false,
			copyModDt: null,
			copyNum: 0,

			optionList: [],
			delModDt: null,
			contLoading: true,
			isSave: false,
		}
	},
	computed: {
		orderTypeCH() {
			let str = ''
			switch (this.orderType) {
				case 'ENTRUST_DETN':
					str = '委托检测'
					break
				case 'CNAS_DETN':
					str = 'CNAS检测'
					break
				case 'AUTONOMY_APP':
					str = '自主上机'
					break
				case 'INSTRUMENT_APP':
					str = '仪器预约'
					break

				default:
					break
			}
			return str
		},
	},
	watch: {
		active: function (newVal, oldVal) {
			try {
				this.getModList(newVal)
			} catch (error) {
				console.log(error)
				this.active = oldVal
			}
		},
	},
	created() {
		this.orderId = '' + this.$route.query.orderId
		this.orderType = this.$route.query.type || ''
		this.goodsPrn = this.$route.query.prn
		this.fromTitle = this.$route.query.title || ''
		this.fromUrl = this.$route.query.from || ''
		this.init()
		this.getStandList()
	},
	methods: {
		getStandList() {
			let params = {
				current: 1,
				size: 10000,
				data: {
					orderId: this.orderId,
				},
			}
			this.$http
				.post(this.$api.goodsApi.funStdList, params)
				.then(({ data }) => {
					this.optionList = data.data.list
				})
				.catch(() => {})
		},
		cellClick(row, column, cell, event, child) {
			console.log('cellClick=>', row, column, cell, event)
			console.log(child, 'childchildchild')
		},
		enterBlur(scope) {
			console.log(scope, 'scopescope')
		},
		esc(scope) {
			console.log(scope, 'scopescope')
			// scope.row[scope.column.property + 'show'] = false
			// scope.row.inventoryShow = false
		},
		init() {
			this.modLoadding = true
			let params = { code: 'ORDER_XD', orderType: this.orderType }
			this.$http
				.get(this.$api.systemApi.orderStep, { params })
				.then(({ data }) => {
					this.stepsInfo = data.data
				})
				.then(() => {
					if (!this.stepsInfo) return
					this.getModList(this.active)
				})
				.catch(() => {
					this.modLoadding = false
				})
		},
		// 根据步骤获取模块信息
		getModList(active) {
			this.modList = null
			this.dataListSelections = []
			let params = {
				orderId: this.orderId,
				moduleIds: this.stepsInfo.childrenList[active].moduleIds,
				subset: this.stepsInfo.childrenList[active].subset,
			}
			this.$http
				.post(this.$api.orderApi.orderFormitem, params)
				.then(({ data }) => {
					console.log(data)
					this.modList = data.data
					this.modLoadding = false
					this.modList.forEach((mod, index) => {
						console.log(mod, index)
						if (mod.childrenList && mod.childrenList.length > 0) {
							mod.childrenList.forEach(child => {
								if (child.layout == 'TABLE') {
									let select = []
									let data = child.data
									data.forEach(item => {
										this.$set(item, 'isCanEdit', true)
										if (item.st == '1') {
											select.push(item)
										}
									})
									this.dataListSelections.push(select)
								}
							})
						}
					})
					this.$nextTick(() => {
						this.dataListSelections &&
							this.dataListSelections.forEach((data, i) => {
								data.forEach(row => {
									this.$refs.itemTable[i] && this.$refs.itemTable[i].toggleRowSelection(row, true)
								})
							})
					})
					this.contLoading = false
				})
				.catch(() => {
					this.modLoadding = false
					this.contLoading = false
				})
		},
		// 上一步
		upHandle() {
			this.isSave = false
			this.contLoading = true
			try {
				Promise.all(this.batchFormVal(this.$refs.Cform, 'false'))
					.then(res => {
						console.log(11111111, res)
						let obj = {}
						res.map(item => {
							if (item.moduleNameEn == 'goodsInfo' || item.moduleNameEn == 'funStdInfo') {
								if (!obj[item['moduleNameEn']]) {
									obj[item['moduleNameEn']] = []
								}
								obj[item['moduleNameEn']].push(item)
							} else {
								obj[item['moduleNameEn']] = item
							}
						})
						let params = {
							orderId: this.orderId,
							...obj,
						}
						if (this.active == 1) {
							params['project'] = this.dataListSelections.reduce((a, b) => a.concat(b))
						}

						if (this.active === this.stepsInfo.childrenList.length - 1) {
							params.isSave = this.isSave
						}
						this.$http
							.post(this.$api.orderApi.updateOrder, params)
							.then(() => {
								this.contLoading = false
								if (--this.active < 0) this.active = 0
							})
							.catch(() => {
								this.contLoading = false
							})
					})
					.catch(e => {
						this.contLoading = false
						console.log(e)
					})

				// this.updateOrder(() => {
				// if (--this.active < 0) this.active = 0
				// })
			} catch (error) {
				console.log(error)
				this.contLoading = false
				return
			}
		},
		// 下一步
		async nextHandle() {
			this.isSave = false
			this.contLoading = true
			try {
				this.updateOrder(() => {
					if (this.active++ >= this.stepsInfo.childrenList.length) this.active = 0
				})
			} catch (error) {
				console.log(error)
				this.contLoading = false
				return
			}
		},
		// 更新订单
		async updateOrder(cb, args) {
			if (this.$refs.Cform) {
				Promise.all(this.batchFormVal(this.$refs.Cform, 'true'))
					.then(res => {
						console.log(11111111)
						let obj = {}
						res.map(item => {
							if (item.moduleNameEn == 'goodsInfo' || item.moduleNameEn == 'funStdInfo') {
								if (!obj[item['moduleNameEn']]) {
									obj[item['moduleNameEn']] = []
								}
								obj[item['moduleNameEn']].push(item)
							} else {
								obj[item['moduleNameEn']] = item
							}
						})
						let params = {
							orderId: this.orderId,
							...obj,
						}
						if (this.active == 1) {
							params['project'] = this.dataListSelections.reduce((a, b) => a.concat(b))
						}

						if (this.active === this.stepsInfo.childrenList.length - 1) {
							params.isSave = this.isSave
						}
						this.$http
							.post(this.$api.orderApi.updateOrder, params)
							.then(() => {
								cb && cb(args)
								if (cb) {
									this.contLoading = true
								} else {
									this.contLoading = false
								}
							})
							.catch(() => {
								this.contLoading = false
							})
					})
					.catch(e => {
						this.$message.warning('请检查表单填写！')
						this.contLoading = false
						console.log(e)
					})
			} else {
				this.contLoading = false
			}
		},

		// 批量获取表单数据
		batchFormVal(forms, isRule) {
			let promises = []
			for (let i = 0; i < forms.length; i++) {
				promises.push(forms[i].getFormVal(isRule))
			}
			return promises
		},
		// 更新产品信息
		updateProdInfo(prn) {
			console.log(prn)
			// let params = {
			//   orderId: this.orderId,
			//   goodsPrn: prn,
			// };
			// this.$http.post(this.$api.orderApi.replaceGoods, params).then(({ data }) => {
			//   console.log(data);
			//   this.getModList(this.active);
			// });
		},
		// 复制
		copyNumHandle: debounce(function (data) {
			this.contLoading = true
			console.log(data)
			this.isSave = false
			if (data) {
				this.contLoading = true
				this.copyNum = data
				this.updateOrder(this.copymod, this.copyModDt)
			} else {
				this.contLoading = false
			}
		}, 300),

		// async copyNumHandle(data) {
		// 	this.contLoading = true
		// 	console.log(data)
		// 	this.isSave = false
		// 	if (data) {
		// 		this.contLoading = true
		// 		this.copyNum = data
		// 		await this.updateOrder(this.copymod, this.copyModDt)
		// 	} else {
		// 		this.contLoading = false
		// 	}
		// },
		// 确认批量删除
		batchDelHandle: debounce(function (data) {
			this.isSave = false
			if (data) {
				this.contLoading = true
				this.updateOrder(this.delHandleBatch, data)
			}
		}, 300),
		// async batchDelHandle(data) {
		// 	this.isSave = false
		// 	if (data) {
		// 		this.contLoading = true
		// 		await this.updateOrder(this.delHandleBatch, data)
		// 	}
		// },
		delHandleBatch(mod) {
			this.contLoading = true
			let params = {
				orderId: this.orderId,
				templateGoodsIdList: mod,
			}
			this.$http
				.post(this.$api.orderApi.deleteGoods, params)
				.then(({ data }) => {
					console.log(data)
					this.$message({
						message: '操作成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.getModList(this.active)
							this.$refs.orderSampleDel.dialogVisible = false
						},
					})
				})
				.catch(() => {
					this.contLoading = false
				})
		},

		// 复制
		async copyHandle(mod) {
			Promise.all(this.batchFormVal(this.$refs.Cform, 'true'))
				.then(() => {
					this.$refs.orderCopyNum.dialogVisible = true
					this.copyModDt = mod
				})
				.catch(() => {
					this.$message.warning('请检查表单填写！')
				})
		},
		copymod(mod) {
			let goodsId = mod.list.filter(item => item.field == 'id')[0]['val']
			let params = {
				orderId: this.orderId,
				templateGoodsId: goodsId,
				number: this.copyNum,
			}
			this.$http
				.post(this.$api.orderApi.copyGoods, params)
				.then(({ data }) => {
					console.log(data)
					this.$message({
						message: '操作成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.getModList(this.active)
						},
					})
				})
				.catch(() => {
					this.contLoading = false
				})
		},
		// 删除
		deleteHandle(mod) {
			this.isSave = false
			this.contLoading = true
			this.updateOrder(this.delHandle, mod)
		},
		// 批量删除样品
		// batchDel: debounce(function (modList) {
		// 	this.contLoading = true
		// 	this.$refs.orderSampleDel.dialogVisible = true
		// 	let dt = JSON.parse(JSON.stringify(modList))
		// 	let arr = []
		// 	this.delModDt = []
		// 	dt.forEach(item => {
		// 		item.template.forEach(it => {
		// 			if (it.field == 'id') {
		// 				arr.push(String(it.val))
		// 			}
		// 		})
		// 	})
		// 	this.delModDt = [...new Set(arr)]
		// 	this.$refs.orderSampleDel.dialogVisible = true
		// }, 100),

		batchDel(modList) {
			// this.contLoading = true
			this.$refs.orderSampleDel.dialogVisible = true
			let dt = JSON.parse(JSON.stringify(modList))
			let arr = []
			this.delModDt = []
			dt.forEach(item => {
				item.template.forEach(it => {
					if (it.field == 'id') {
						arr.push(String(it.val))
					}
				})
			})
			this.delModDt = [...new Set(arr)]
			this.$refs.orderSampleDel.dialogVisible = true
		},
		delHandle(mod) {
			let goodsId = mod.list.filter(item => item.field == 'id')[0]['val']
			let params = {
				orderId: this.orderId,
				templateGoodsId: goodsId,
			}
			this.$http
				.post(this.$api.orderApi.deleteGoods, params)
				.then(({ data }) => {
					console.log(data)
					this.$message({
						message: '操作成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.getModList(this.active)
						},
					})
				})
				.catch(() => {
					this.contLoading = false
				})
		},
		// 表格多选
		selectionItemsHandle(val, index, data) {
			// console.log(this.dataListSelections, '勾选表格时')
			// console.log(val, '勾选表格时')
			// console.log(data,'dataaaaaaaaaa')
			// console.log(index, '操作的是第几项')
			data.forEach(item => {
				item.isCanEdit = true
			})
			data.forEach(v => {
				val.forEach(it => {
					if (it.id == v.id) {
						v.isCanEdit = false
					}
				})
			})
			this.dataListSelections[index] = val

			// console.log(this.dataListSelections, '勾选表格后')
		},

		updateTime(obj) {
			console.log(obj)
			let params = {
				orderId: this.orderId,
				startTime: obj.startTime,
				endTime: obj.endTime,
			}
			this.$http
				.post(this.$api.orderApi.updateAppt, params)
				.then(({ data }) => {
					console.log(data)
					this.$message({
						message: '更改成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.timepanelVisible = false
						},
					})
				})
				.catch(() => {
					this.contLoading = false
				})
		},

		// 提交订单
		submitFormHandle: debounce(function (st) {
			this.isSave = false
			if (st) {
				console.log(st, 'sttttttttttttt')
				this.isSave = true
				// await this.updateOrder()
				try {
					this.updateOrder(() => {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.contLoading = false
								//this.$router.push({ name: "home" });
							},
						})
						return
					})
				} catch (error) {
					console.log(error)
					this.contLoading = false
					return
				}

				return
			}
			if (this.$refs.Cform) {
				Promise.all(this.batchFormVal(this.$refs.Cform))
					.then(res => {
						console.log(res)
						let obj = {}
						res.map(item => {
							if (!obj[item['moduleNameEn']]) {
								obj[item['moduleNameEn']] = []
							}
							obj[item['moduleNameEn']].push(item)
						})
						let params = {
							orderId: this.orderId,
							project: this.dataListSelections.reduce((a, b) => a.concat(b)),
							...obj,
						}
						console.log(params)
						this.contLoading = true
						this.$http
							.post(this.$api.orderApi.orderSubmit, params)
							.then(({ data }) => {
								if (data.data && data.data.code == 0) {
									this.orderFailVisible = true
									this.$nextTick(() => {
										this.$refs.orderFail.init(this.orderId, this.orderType)
									})
								} else {
									if (data.code == 200) {
										this.orderSuccessVisible = true
										this.$nextTick(() => {
											this.$refs.orderSuccess.init(this.orderId, this.orderType)
										})
									} else {
										this.orderFailVisible = true
										this.$nextTick(() => {
											this.$refs.orderFail.init(this.orderId, this.orderType)
										})
									}
								}
								this.contLoading = false
							})
							.catch(() => {
								this.contLoading = false
							})
					})
					.catch(() => {
						this.$message.warning('请检查表单填写！')
						this.contLoading = false
					})
			}
		}, 300),

		submitFormHandle1(st) {
			this.isSave = false
			if (st) {
				console.log(st, 'sttttttttttttt')
				this.isSave = true
				// await this.updateOrder()
				try {
					this.updateOrder(() => {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.contLoading = false
								//this.$router.push({ name: "home" });
							},
						})
						return
					})
				} catch (error) {
					console.log(error)
					this.contLoading = false
					return
				}

				return
			}
			if (this.$refs.Cform) {
				Promise.all(this.batchFormVal(this.$refs.Cform))
					.then(res => {
						console.log(res)
						let obj = {}
						res.map(item => {
							if (!obj[item['moduleNameEn']]) {
								obj[item['moduleNameEn']] = []
							}
							obj[item['moduleNameEn']].push(item)
						})
						let params = {
							orderId: this.orderId,
							project: this.dataListSelections.reduce((a, b) => a.concat(b)),
							...obj,
						}
						console.log(params)
						this.contLoading = true
						this.$http
							.post(this.$api.orderApi.orderSubmit, params)
							.then(({ data }) => {
								if (data.data && data.data.code == 0) {
									this.orderFailVisible = true
									this.$nextTick(() => {
										this.$refs.orderFail.init(this.orderId, this.orderType)
									})
								} else {
									if (data.code == 200) {
										this.orderSuccessVisible = true
										this.$nextTick(() => {
											this.$refs.orderSuccess.init(this.orderId, this.orderType)
										})
									} else {
										this.orderFailVisible = true
										this.$nextTick(() => {
											this.$refs.orderFail.init(this.orderId, this.orderType)
										})
									}
								}
								this.contLoading = false
							})
							.catch(() => {
								this.contLoading = false
							})
					})
					.catch(() => {
						this.$message.warning('请检查表单填写！')
						this.contLoading = false
					})
			}
		},
		// 显示时间面板
		showTimePanel() {
			this.timepanelVisible = true
			this.$nextTick(() => {
				this.$refs.timepanel.init(this.goodsPrn, this.orderType, this.orderId)
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.mod-order {
	.content {
		background: #fff;
		margin-top: 16px;
		margin-bottom: 20px;
		border-radius: 16px;
		.top_breadcrumb {
			padding: 14px 30px;
			border-bottom: 1px solid #f1f1f1;
			.home_img {
				margin-right: 6px;
				height: 14px;
				margin-top: -4px;
			}
		}
		.main {
			.mod-title {
				text-align: center;
				overflow: hidden;
				h1 {
					font-size: 24px;
				}
				.under-line {
					display: inline-block;
					width: 32px;
					margin-top: 12px;
					border: 2px solid #1460ae;
					background: #1460ae;
					border-radius: 4px;
				}
			}
		}
		.main-content {
			position: relative;
			padding: 30px 88px;

			.modlist {
				padding: 20px 0;
				.topbox {
					display: flex;
					justify-content: space-between;
					background: #f2f3f5;
					border-radius: 8px;
					margin-bottom: 20px;
					.modName {
						margin: 0;
						font-size: 14px;
						color: #333;
						padding: 6px 16px;
					}
					.btnfun {
						display: flex;
						align-items: center;
						text-align: center;
					}
				}
			}
			.moudlePanle {
				margin-bottom: 30px;
			}

			.btncontrol {
				position: relative;
				top: 6px;
				margin-left: 15px;
				width: 143px;
			}
		}

		.btngroup {
			text-align: center;
			margin-top: 40px;

			button {
				width: 150px;
			}

			.next {
				background: #1460ae;
			}
		}
	}
}
</style>
